import React, { useState, useEffect } from "react";
import _ from "lodash";
import cx from "classnames";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import WarningBanner from "Components/warningBanner/WarningBanner";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import s from "./limitsManagers.scss";
import qboxmailApi from "@/qboxmailApi";
import SmallModal from "Components/smallModal/smallModal";
import { Icon, trash } from "Icons/index";
import { alertSuccess, alertError } from "Utils/alerts";
import Loader from "Components/loader/Loader";
import ConfirmModal from "Components/confirmModal/ConfirmModal";

const api = new qboxmailApi({ useCookie: true });

export default class ManagerDeliverySettings extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      viewFields: ["max_delivery_accounts", "max_delivery_domains"],
      isAssignResourceModalOpen: false,
      resourceToUnassign: null,
      isUnassigning: false,
    };
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  submit(e) {
    e.preventDefault();
    this.props.submitForm(this.props.formData, this.state.viewFields);
  }

  clearDomainsSelect(values) {
    this.props.setFormFieldValue({ ...values, domain_codes: [] });
  }

  render() {
    const {
      setFormFieldValue,
      formErrors,
      deliveryResourcesWithoutManager,
      isLoadingDeliveryResources,
      manager,
      isFormLoading,
      formData,
      refreshManager,
      getDeliveryResourcesWithoutManagers,
    } = this.props;

    return (
      <form className={s.general} method="post" onSubmit={this.submit}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && !formErrors.onForm && (
              <WarningBanner color="yellow-text" msg={t("infoMsg.unsaveChanged")} />
            )}

            {formErrors.onForm && <WarningBanner msg={formErrors.onForm} color="red" />}
          </div>

          <div className={s.infoBtnGroup}>
            <Button docsKey="managers_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>

        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.deliverySettings.newResourcesLimit.title")}</div>
              <div
                className="sectionDesc"
                dangerouslySetInnerHTML={{
                  __html: t("settings.sections.deliverySettings.newResourcesLimit.desc"),
                }}
              ></div>
            </div>
            <div className="formsSectionSP">
              <div className="flex gap-2 inputFull2">
                <Input
                  type="number"
                  name="max_delivery_accounts"
                  hint={
                    <TranslatedString
                      subs={{
                        tot: manager.delivery_account_ids?.length || 0,
                      }}
                    >
                      input.hint.managerAssignedNow
                    </TranslatedString>
                  }
                  onChange={setFormFieldValue}
                  errors={formErrors.max_delivery_accounts}
                  value={formData.max_delivery_accounts}
                  label={<TranslatedString>input.label.maxNewDeliveryAccountsAvailable</TranslatedString>}
                  min={-1}
                  max={99999}
                  required
                />

                <Input
                  name="max_delivery_domains"
                  type="number"
                  hint={
                    <TranslatedString subs={{ tot: manager.delivery_domain_codes?.length || 0 }}>
                      input.hint.managerAssignedNow
                    </TranslatedString>
                  }
                  onChange={setFormFieldValue}
                  errors={formErrors.max_delivery_domains}
                  value={formData.max_delivery_domains}
                  label={<TranslatedString>input.label.maxNewDeliveryDomainsAvailable</TranslatedString>}
                  min={-1}
                  max={99999}
                  required
                />
              </div>
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.deliverySettings.assignAccounts.title")}</div>
              <div className="sectionDesc">{t("settings.sections.deliverySettings.assignAccounts.desc")}</div>
            </div>
            <div className="!flex !flex-col formsSectionSP">
              <div className="text-sm">
                <div className="">
                  {t("delivery.accounts.list.title")} - {manager.selected_delivery_account_data?.length || 0}
                </div>

                <div className="mb-6">
                  <StripedList
                    items={manager.selected_delivery_account_data || []}
                    identifier="id"
                    className="max-h-40"
                  >
                    {(account) => {
                      return (
                        <div className="flex items-center justify-between">
                          {account.id} - {account.description}
                          <div
                            className="flex items-center justify-center p-1 cursor-pointer"
                            onClick={() => {
                              this.setState({ resourceToUnassign: account });
                            }}
                          >
                            <Icon svg={trash} color="#d92f20" />
                          </div>
                        </div>
                      );
                    }}
                  </StripedList>
                </div>

                <div className="">
                  {t("delivery.managedDomains.list.title")} - {manager.selected_delivery_domain_data?.length || 0}
                </div>

                <div className="mb-6">
                  <StripedList items={manager.selected_delivery_domain_data || []} identifier="id" className="max-h-40">
                    {(domain) => {
                      return (
                        <div className="flex items-center justify-between">
                          {domain.name}

                          <div
                            className="flex items-center justify-center p-1 cursor-pointer"
                            onClick={() => {
                              this.setState({ resourceToUnassign: domain });
                            }}
                          >
                            <Icon svg={trash} color="#d92f20" />
                          </div>
                        </div>
                      );
                    }}
                  </StripedList>
                </div>
              </div>

              <div className="flex flex-col gap-2">
                {!isLoadingDeliveryResources && !deliveryResourcesWithoutManager && (
                  <WarningBanner fullWidth msg={t("delivery.manager.noFreeResources")}></WarningBanner>
                )}

                <Button
                  type="button"
                  color="outline"
                  loading={isLoadingDeliveryResources}
                  onClick={() => this.setState({ isAssignResourceModalOpen: true })}
                  disabled={!isLoadingDeliveryResources && !deliveryResourcesWithoutManager}
                >
                  button.assignAccountOrDomain
                </Button>
              </div>

              <ConfirmUnassignModal
                isOpen={Boolean(this.state.resourceToUnassign)}
                resourceToUnassign={this.state.resourceToUnassign}
                managerCode={manager.code}
                onCancel={() => this.setState({ resourceToUnassign: null })}
                onSuccess={() => {
                  refreshManager();
                  getDeliveryResourcesWithoutManagers();
                  this.setState({ resourceToUnassign: false });
                }}
              />

              <AssignResourceModal
                getDeliveryResourcesWithoutManagers={this.props.getDeliveryResourcesWithoutManagers}
                deliveryResourcesWithoutManager={deliveryResourcesWithoutManager}
                isOpen={this.state.isAssignResourceModalOpen}
                managerCode={manager.code}
                refreshManager={refreshManager}
                currentLimits={{
                  max_delivery_accounts: formData.max_delivery_accounts,
                  max_delivery_domains: formData.max_delivery_domains,
                }}
                onCancel={() => this.setState({ isAssignResourceModalOpen: false })}
                onSuccess={() => {
                  refreshManager();
                  getDeliveryResourcesWithoutManagers();
                  this.setState({ isAssignResourceModalOpen: false });
                }}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const ConfirmUnassignModal = ({ isOpen = false, resourceToUnassign, onSuccess, onCancel, managerCode }) => {
  const [previewing, setPreviewing] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setPreviewing(false);
      setPreviewData(null);
      return;
    }
    preview().then(() => {
      console.log("getting preview");
    });
  }, [isOpen]);

  const preview = async () => {
    setPreviewing(true);
    const previewResult = await api.previewAssignDeliveryResourceToManager(
      managerCode,
      resourceToUnassign.id || resourceToUnassign.code
    );

    // we need to clean the current resources from
    // the preview for UI purpose
    previewResult.accounts = previewResult.accounts.filter((a) => a.id !== resourceToUnassign.id);
    previewResult.domains = previewResult.domains.filter((d) => d.code !== resourceToUnassign.code);

    setPreviewData(previewResult);
    setPreviewing(false);
  };

  const doUnassign = async () => {
    setIsSaving(true);

    try {
      await api.unassignDeliveryResourceToManager(managerCode, resourceToUnassign.id || resourceToUnassign.code);
      alertSuccess(t("alert.managerUpdatedSuccess"));
      if (onSuccess) onSuccess();
    } catch (err) {
      alertError(t("alert.wrong"));
    }

    setIsSaving(false);
  };

  return (
    <SmallModal
      title={t("modal.manager.delivery.confirm.title")}
      opened={isOpen}
      closeModal={onCancel}
      showCloseIcon={true}
      footerComponent={
        <div className="flex !justify-between w-full">
          <Button color="outline" type="button" onClick={onCancel}>
            button.cancel
          </Button>

          <Button
            loading={isSaving}
            color="red"
            onClick={() => {
              doUnassign();
            }}
          >
            button.remove
          </Button>
        </div>
      }
    >
      <div className="p-4">
        <div
          className="mb-6"
          dangerouslySetInnerHTML={{
            __html: t("modal.manager.delivery.confirm.body", null, {
              resource: resourceToUnassign?.description || resourceToUnassign?.code,
            }),
          }}
        ></div>

        {(resourceToUnassign?.domains || resourceToUnassign?.accounts) && (
          <>
            {previewing && (
              <div className="flex flex-col items-center justify-center gap-1 ">
                <Loader iconSize="2rem" />
                <div className="text-sm text-[--accent]">{t("delivery.manager.loadingLinkedResources")}</div>
              </div>
            )}

            {(previewData?.accounts?.length > 0 || previewData?.domains?.length > 0) && (
              <div className="my-4">
                <WarningBanner color="yellow" msg={t("delivery.manager.alertGeneric")} />
              </div>
            )}

            {previewData?.accounts?.length > 0 && (
              <>
                <div>{t("delivery.accounts.list.title")}</div>
                <StripedList items={previewData.accounts} identifier="code" className="max-h-40">
                  {(account) => {
                    return (
                      <div>
                        {account.id} - {account.description}
                        <div className="text-xs opacity-50">
                          {t("infoMsg.linkedToDomain", null, { dom: account.linked_to })}
                        </div>
                      </div>
                    );
                  }}
                </StripedList>
              </>
            )}

            {previewData?.domains?.length > 0 && (
              <>
                <div className="mt-6">{t("livery.managedDomains.list.title")}</div>
                <StripedList items={previewData.domains} identifier="code" className="max-h-40">
                  {(domain) => {
                    return (
                      <div>
                        {domain.name}

                        <div className="text-xs opacity-50">
                          {t("infoMsg.linkedToAccount", null, { acc: domain.linked_to })}
                        </div>
                      </div>
                    );
                  }}
                </StripedList>
              </>
            )}
          </>
        )}
      </div>
    </SmallModal>
  );
};

const AssignResourceModal = ({
  isOpen = false,
  deliveryResourcesWithoutManager = {},
  managerCode,
  onSuccess,
  onCancel,
  currentLimits,
}) => {
  /* 
    possibile states:
      - pick-resource-type
      - pick-account
      - confirm-pick-account
      - pick-domain
      - confirm-pick-domain
      - saving
  */

  const [state, setState] = useState("pick-resource-type");
  const [selectedResource, setSelectedResource] = useState(null);
  const [saving, setSaving] = useState(false);
  const [previewing, setPreviewing] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [error, setError] = useState(null);

  const reset = () => {
    setState("pick-resource-type");
    setSelectedResource(null);
    setError(null);
  };

  const preview = async (resource) => {
    setPreviewing(true);
    setSelectedResource(resource);
    const previewResult = await api.previewAssignDeliveryResourceToManager(managerCode, resource.id || resource.code);

    // we need to clean the current resources from
    // the preview for UI purpose
    previewResult.accounts = previewResult.accounts.filter((a) => a.id !== resource.id);
    previewResult.domains = previewResult.domains.filter((d) => d.code !== resource.code);

    setPreviewData(previewResult);
    setPreviewing(false);
    setState(state === "pick-domain" ? "confirm-pick-domain" : "confirm-pick-account");
  };

  const doAssign = async (values) => {
    setSaving(true);
    setError(null);

    try {
      await api.assignDeliveryResourceToManager(managerCode, {
        id: selectedResource.id || selectedResource.code,
        ...currentLimits,
      });
      if (onSuccess) onSuccess();
      reset();
      alertSuccess(t("alert.managerUpdatedSuccess"));
    } catch (err) {
      alertError(t("alert.wrong"));

      if (err.status < 500) {
        const body = await err.json();
        setError(body.message);
      }
    }

    setSaving(false);
    return;
  };

  return (
    <SmallModal
      title={t("managers.settings.deliverySettings.assignResource.modalTitle")}
      opened={isOpen}
      closeModal={() => {
        reset();
        onCancel();
      }}
      showCloseIcon={true}
      footerComponent={
        state === "pick-account" || state === "pick-domain" ? (
          <div className="flex !justify-start w-full ">
            <Button
              color="outline"
              type="button"
              onClick={() => {
                setState("pick-resource-type");
              }}
            >
              button.back
            </Button>
          </div>
        ) : state === "confirm-pick-account" || state === "confirm-pick-domain" ? (
          <div className="flex !justify-between w-full">
            <Button
              color="outline"
              type="button"
              onClick={() => {
                setSelectedResource(null);
                setError(null);

                if (state === "confirm-pick-account") {
                  setState("pick-account");
                }

                if (state === "confirm-pick-domain") {
                  setState("pick-domain");
                }
              }}
            >
              button.back
            </Button>

            <Button
              loading={saving}
              color="green"
              onClick={() => {
                doAssign();
              }}
            >
              button.confirm
            </Button>
          </div>
        ) : (
          <div className="flex w-full gap-10 !justify-between">
            <Button color="outline" onClick={() => setState("pick-account")}>
              delivery.manager.pick.button.account
            </Button>
            <Button color="outline" onClick={() => setState("pick-domain")}>
              delivery.manager.pick.button.domain
            </Button>
          </div>
        )
      }
    >
      {state === "pick-resource-type" && (
        <div className="flex flex-col">
          <div className="pb-3 font-semibold">{t("delivery.manager.pick.title")}</div>

          <p> {t("delivery.manager.pick.body")}</p>
        </div>
      )}

      {state === "pick-account" && (
        <div className="flex flex-col pb-6">
          <div className="pb-3 font-semibold">{t("delivery.manager.pick.account")}</div>

          <div className="mb-4">
            <WarningBanner color="yellow" msg={t("delivery.manager.alert")} />
          </div>

          <StripedList
            items={deliveryResourcesWithoutManager.accounts}
            identifier="id"
            className="max-h-40"
            loading={previewing}
            onItemClick={(account) => preview(account)}
          >
            {(account) => {
              return (
                <div>
                  {account.id} - {account.description} -{" "}
                  <span className="opacity-50">
                    {account.domains.length} {t("delivery.domains.list.title")}
                  </span>
                </div>
              );
            }}
          </StripedList>
        </div>
      )}

      {state === "pick-domain" && (
        <div className="flex flex-col pb-6">
          <div className="pb-3 font-semibold">{t("delivery.manager.pick.domain")}</div>

          <div className="mb-4">
            <WarningBanner color="yellow" msg={t("delivery.manager.alertDomains")} />
          </div>

          <StripedList
            items={deliveryResourcesWithoutManager.domains}
            identifier="code"
            className="max-h-40"
            onItemClick={(domain) => preview(domain)}
            loading={previewing}
          >
            {(domain) => {
              return (
                <div>
                  {domain.name} -{" "}
                  <span className="opacity-50">
                    {domain.accounts.length} {t("table.header.accounts")}
                  </span>
                </div>
              );
            }}
          </StripedList>
        </div>
      )}

      {state === "confirm-pick-domain" && (
        <div className="flex flex-col">
          <div className="pb-3 font-semibold">
            {t("delivery.manager.confirmDomainAssign", null, {
              accountId: selectedResource.id,
            })}
          </div>

          <div className="">{t("delivery.domains.list.title")}</div>
          <div className="mb-6">
            <StripedList items={[selectedResource]} identifier="id" className="max-h-40">
              {(domain) => {
                return <div>{domain.name}</div>;
              }}
            </StripedList>
          </div>

          {(previewData.accounts.length > 0 || previewData.domains.length > 0) && (
            <div className="mb-4">
              <WarningBanner color="yellow" msg={t("delivery.manager.alertGeneric")} />
            </div>
          )}

          {previewData.accounts.length > 0 && (
            <>
              <div>
                {t("delivery.accounts.list.title")} - {previewData.accounts.length}
              </div>
              <StripedList items={previewData.accounts} identifier="code" className="max-h-40">
                {(account) => {
                  return (
                    <div>
                      {account.id} - {account.description}
                      <div className="text-xs opacity-50">
                        {t("infoMsg.linkedToDomain", null, { dom: account.linked_to })}
                      </div>
                    </div>
                  );
                }}
              </StripedList>
            </>
          )}

          {previewData.domains.length > 0 && (
            <>
              <div className="mt-6">
                {t("delivery.domains.list.title")} - {previewData.domains.length}
              </div>
              <StripedList items={previewData.domains} identifier="code" className="max-h-40">
                {(domain) => {
                  return (
                    <div>
                      {domain.name}

                      <div className="text-xs opacity-50">
                        {t("infoMsg.linkedToAccount", null, { acc: domain.linked_to })}
                      </div>
                    </div>
                  );
                }}
              </StripedList>
            </>
          )}

          {error && <WarningBanner color="light-red" className="w-full max-w-full my-2" msg={error} />}
        </div>
      )}

      {state === "confirm-pick-account" && (
        <div className="flex flex-col">
          <div className="pb-3 font-semibold">
            {t("delivery.manager.confirmAccountAssign", null, {
              accountId: selectedResource.id,
            })}
          </div>

          <div className="">{t("delivery.accounts.list.title")}</div>
          <div className="mb-6">
            <StripedList items={[selectedResource]} identifier="id" className="max-h-40">
              {(account) => {
                return (
                  <div>
                    {account.id} - {account.description}
                  </div>
                );
              }}
            </StripedList>
          </div>

          {(previewData.accounts.length > 0 || previewData.domains.length > 0) && (
            <p className="mb-4">
              <WarningBanner color="yellow" msg={t("delivery.manager.alertGeneric")} />
            </p>
          )}

          {previewData.domains.length > 0 && (
            <>
              <div>
                {t("delivery.domains.list.title")} - {previewData.domains.length}
              </div>
              <StripedList items={previewData.domains} identifier="code" className="max-h-40">
                {(domain) => {
                  return (
                    <div>
                      {domain.name}

                      <div className="text-xs opacity-50">
                        {t("infoMsg.linkedToAccount", null, { acc: domain.linked_to })}
                      </div>
                    </div>
                  );
                }}
              </StripedList>
            </>
          )}

          {previewData.accounts.length > 0 && (
            <>
              <div className="mt-6">
                {t("delivery.accounts.list.title")} - {previewData.accounts.length}
              </div>
              <StripedList items={previewData.accounts} identifier="code" className="max-h-40">
                {(account) => {
                  return (
                    <div>
                      {account.id} - {account.description}
                      <div className="text-xs opacity-50">
                        {t("infoMsg.linkedToDomain", null, { dom: account.linked_to })}
                      </div>
                    </div>
                  );
                }}
              </StripedList>
            </>
          )}

          {error && <WarningBanner color="light-red" className="w-full max-w-full my-2" msg={error} />}
        </div>
      )}
    </SmallModal>
  );
};

const StripedList = ({ items, onItemClick, identifier, children, className, loading }) => {
  return (
    <div className="relative">
      {loading && (
        <div className="absolute top-0 bottom-0 left-0 right-0 z-20 flex flex-col items-center justify-center gap-1 bg-white pointer-events-none">
          <Loader iconSize="2rem" />
          <div className="text-sm text-[--accent]">{t("delivery.manager.loadingLinkedResources")}</div>
        </div>
      )}

      <div
        className={cx("flex flex-col border border-solid border-[--bg-d15] rounded ", className, {
          "overflow-y-hidden": loading,
          "overflow-y-auto": !loading,
        })}
      >
        {items.length === 0 && <div className="py-2 text-center opacity-50">{t("infoMsg.noElements")}</div>}

        {items.map((item, i) => (
          <div
            className={cx("py-2 px-2 border-b border-b-solid border-[--bg-d15]", {
              "bg-[--bg]": i % 2 !== 0,
              "cursor-pointer": !!onItemClick,
              "hover:bg-[--accent-l35] hover:text-[--accent]": !!onItemClick,
            })}
            key={item[identifier]}
            onClick={() => onItemClick && onItemClick(item)}
          >
            {children(item)}
          </div>
        ))}
      </div>
    </div>
  );
};
